// Omgevingen, eigen thema en agendaverbindingen (Duits). Zelfde vorm als omgevingApp.nl.ts.
export const appOmgevingDe = {
    spaces: {
        mine: 'Mein Bereich',
        switchLabel: 'Bereich wechseln',
        choose: 'Bereich wählen',
        private: 'Privat',
        shared: 'Geteilt',
        dialogTitle: 'Wähle deinen Bereich',
        dialogBody: 'Plane für dich allein oder gemeinsam mit anderen.',
        close: 'Schließen',
        current: 'Aktueller Bereich',
        privateHint: 'Privat · nur für dich',
        sharedHint: 'Geteilt · gemeinsam planen',
        opening: 'Bereich wird geöffnet…',
        failed: 'Wechseln hat nicht geklappt. Versuche es noch einmal.',
        personalNotice: 'Mein Bereich · privat: Diese Planung und diese Daten sind nur für dich. Wechsle oben zu Geteilt, um gemeinsam zu planen.',
    },
    personalTheme: {
        title: 'Mein Design',
        body: 'Wähle, wie deine App aussieht. Die Wahl wird in deinem Konto gespeichert und gilt auf all deinen Geräten. Das gemeinsame Board und andere Nutzer behalten ihr eigenes Design.',
        auto: 'Design meines Haushalts folgen',
        warm: 'Warm und verspielt',
        calm: 'Sanft und ruhig',
        minimal: 'Minimalistisch',
        graphic: 'Klar und grafisch',
        contrast: 'Groß und kontrastreich',
        failed: 'Dein Design konnte nicht geladen werden.',
        retry: 'Erneut versuchen',
        saved: 'Dein Design ist gespeichert.',
    },
    calendarSync: {
        title: 'Meine Kalenderverbindungen',
        intro: 'Verbinde deinen primären Google- oder Microsoft-Kalender mit {name}. Nur du verwaltest diese Verbindung. In diesem Bereich gelten für importierte Termine die üblichen Zugriffsrechte.',
        details: 'Automatisch alle fünf Minuten, von 30 Tagen zurück bis ein Jahr voraus. Wiederholungen werden als einzelne Termine synchronisiert. Nur Titel, Zeiten, Ort und Notizen werden ausgetauscht, keine Teilnehmer oder Einladungen. Besprechungen mit Teilnehmern bearbeitest du in Google oder Outlook.',
        connected: 'Kalender verbunden. Wähle Jetzt synchronisieren, um sofort zu beginnen.',
        failed: 'Verbinden hat nicht geklappt oder wurde abgebrochen. Versuche es noch einmal.',
        retry: 'Erneut versuchen',
        provider: 'Kalenderdienst',
        google: 'Google Kalender / Gmail',
        googleShort: 'Google Kalender',
        microsoft: 'Microsoft 365 / Outlook',
        direction: 'Synchronisierungsrichtung',
        import: 'Nur zu AMUMIN',
        export: 'Nur von AMUMIN',
        both: 'In beide Richtungen',
        scope: 'Welche Termine senden?',
        scopeMine: 'Termine, an denen ich beteiligt bin',
        scopeAll: 'Alle Termine in diesem Bereich',
        notConfigured: 'Dieser Kalenderdienst muss noch von AMUMIN aktiviert werden. Die bestehenden Kalenderabos bleiben verfügbar.',
        alreadyConnected: 'Bereits verbunden',
        connect: 'Kalender verbinden',
        lastSync: 'Zuletzt synchronisiert: {when}',
        neverSynced: 'Noch nicht synchronisiert',
        conflicts: {
            one: '{count} Termin wurde auf beiden Seiten geändert oder gelöscht. Er wurde behalten. Prüfe beide Kalender und wähle, welche Version du behalten möchtest.',
            other: '{count} Termine wurden auf beiden Seiten geändert oder gelöscht. Sie wurden behalten. Prüfe beide Kalender und wähle, welche Version du behalten möchtest.',
        },
        synced: 'Synchronisierung abgeschlossen.',
        syncNow: 'Jetzt synchronisieren',
        keepLocal: 'AMUMIN-Versionen behalten',
        keepRemote: 'Externe Versionen behalten',
        disconnect: 'Verbindung beenden',
        disconnectHint: 'Beenden löscht keine Termine. Um die Richtung zu ändern, beende die Verbindung und verbinde neu.',
        personalLinks: 'Dein persönlicher Kalender bleibt privat. Geteilte Abo-Links erstellst du in deinem geteilten Bereich.',
    },
    errors: {
        personalSpacePrivate: 'Dein persönlicher Bereich ist nur für dich. Wechsle zu Geteilt, um Leute einzuladen oder ein Board zu verbinden.',
        providerNotConfigured: 'Dieser Kalenderdienst ist von AMUMIN noch nicht aktiviert.',
        alreadyConnected: 'Dieser Kalenderdienst ist bereits verbunden. Beende zuerst die bestehende Verbindung, um neu zu verbinden.',
    },
    rideOpen: {
        dropoff: 'Wer bringt {names} zu {title}?',
        dropoffNoNames: 'Wer bringt zu {title}?',
        pickup: 'Wer holt {names} von {title} ab?',
        pickupNoNames: 'Wer holt von {title} ab?',
    },
    notMeHint: '{link}: Nutze den Link unten in der E-Mail.',
    ingredientsPlaceholder: '500 g Hackfleisch\n1 Zwiebel\n1 Dose Tomaten',
};
//# sourceMappingURL=omgevingApp.de.js.map